module.exports = __webpack_public_path__ + "static/media/rideBackground.17b24471.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Ride/rideBackground.svg
// module id = 921
// module chunks = 0